import { Component, Input } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { UpgradePromptComponent } from '@employer/app/components/upgrade-prompt/upgrade-prompt.component'

export enum AutomationTypeDisplayNames {
  ApplicationAutoResponse = 'Application Auto Response',
  RequestedUpdate = 'Requested Update',
  AutomatedQuestions = 'Automated Questions',
  CultureIndexSurvey = 'Culture Index Survey',
}

@Component({
  selector: 'automation-upgrade-prompt',
  standalone: true,
  imports: [TranslateModule, UpgradePromptComponent],
  template: `
    <upgrade-prompt
      class="e11-mb-4 e11-block"
      variant="modal-link"
      icon="help_outline"
      [featureName]="'Automation Configuration - ' + automationType"
      [linkText]="'Why am I unable to edit this?'"
      [headline]="'Why am I unable to edit this?'"
      [ctaText]="''"
    >
      <div upgradeModalBody>
        <p>
          {{ 'If you are unable to edit the automation settings for ' | translate }}
          <span class="e11-text-skin-danger e11-font-primary-bold">{{ automationType }}</span>
          {{
            ' it is most likely  because the plan your company currently has only includes the basic version of automation, so the message text, delays, and message sender can’t be edited.'
              | translate
          }}
        </p>
        <p>
          {{
            'To be able to edit the message as well as change the message sender you will need to upgrade to the premium version of automation. You will then be able to fully customize the message text that gets sent out, including the ability to send videos and attachments.'
              | translate
          }}
        </p>
        <p>
          {{
            'To learn more and change your plan contact your account Administrator or contact a Cnect Customer Success representative.' | translate
          }}
        </p>
      </div>
    </upgrade-prompt>
  `,
})
export class AutomationUpgradePromptComponent {
  @Input({ required: true }) automationType!: AutomationTypeDisplayNames
}
